enum EManagerCompanyUsersBulkAction {
  ENABLE = 'enable',
  DISABLE = 'disable',
  SUBSCRIBE_SALES = 'subscribe-sales',
  UNSUBSCRIBE_SALES = 'unsubscribe-sales',
  SUBSCRIBE_LETTINGS = 'subscribe-lettings',
  UNSUBSCRIBE_LETTINGS = 'unsubscribe-lettings',
}

type TManagerCompanyUsersBulkActionStatuses = {
  [EManagerCompanyUsersBulkAction.ENABLE]: boolean;
  [EManagerCompanyUsersBulkAction.DISABLE]: boolean;
  [EManagerCompanyUsersBulkAction.SUBSCRIBE_SALES]: boolean;
  [EManagerCompanyUsersBulkAction.UNSUBSCRIBE_SALES]: boolean;
  [EManagerCompanyUsersBulkAction.SUBSCRIBE_LETTINGS]: boolean;
  [EManagerCompanyUsersBulkAction.UNSUBSCRIBE_LETTINGS]: boolean;
};

type TBulkActionOptionsConfigItem = {
  action: EManagerCompanyUsersBulkAction;
  title: string;
};

type TLoginLink = {
  link: string;
};

export type { TManagerCompanyUsersBulkActionStatuses, TBulkActionOptionsConfigItem, TLoginLink };

export { EManagerCompanyUsersBulkAction };
